import React from "react";
import { Route, Switch } from "react-router-dom";
import { Container } from "react-bootstrap";
import { UserProvider } from "./components/context/UserProvider";
import ProtectedRoute from "./components/Routing/ProtectedRoute";
import CDKHeader from "./components/common/CDKHeader";
import ForgotPassword from "./components/Login/ForgotPassword";
import ChangePassword from "./components/Login/ChangePassword";
import CandidateForm from "./components/CandidateForm/CandidateForm";
import CandidateList from "./components/RecruiterView/CandidateList";
import RecruitersList from "./components/RecruitersList/RecruitersList";
import CandidateReport from "./components/CandidateReports/CandidateReport";
import Login from "./components/Login/Login";
import AddUser from "./components/Users/AddUser";
import SubmitPage from "./components/CandidateForm/SubmitPage";
import OnboardingCandidatesReport from "./components/OnboardingCandidatesReport/OnboardingCandidatesReport";
import OnboardingForms from "./components/OnboardingForms/Forms/OnboardingForms";
import OnboardingPDF from "./components/OnboardingForms/PDFTemplates";
import OnboardingSubmitPage from "./components/OnboardingForms/Forms/OnboardingSubmitPage";
import SEZForm from "./components/SEZForm/SEZForm";
import SEZPDF from "./components/SEZForm/SEZPDF";
import SEZCandidateList from "./components/SEZForm/SEZCandidateList";

import LeaveAndGratuityForm from "./components/EmployeeExit/LeaveAndGratuityForm";
import ExitEmployeeList from "./components/EmployeeExit/EmployeeList";
import ExitPDF from "./components/EmployeeExit/PDF";

const App = () => {
  return (
    <UserProvider>
      <Container fluid className="app-container h-100 overflow-auto min-vh-100">
        <CDKHeader />
        <div className="content">
          <Switch>
            <Route exact component={Login} path="/" />
            <ProtectedRoute
              component={CandidateForm}
              key="CandidateForm"
              path="/CandidateForm"
            />
            <ProtectedRoute
              component={CandidateList}
              key="CandidateList"
              path="/CandidateList"
              displaySideNavBar={true}
            />
            <ProtectedRoute
              component={RecruitersList}
              key="RecruitersList"
              path="/RecruitersList"
              displaySideNavBar={true}
            />
            <ProtectedRoute
              component={CandidateReport}
              key="CandidateReport"
              path="/CandidateReport"
            />
            <ProtectedRoute
              component={AddUser}
              key="AddUser"
              path="/AddUser"
              displaySideNavBar={true}
            />
            <ProtectedRoute
              component={SubmitPage}
              key="SubmitPage"
              path="/SubmitPage"
            />
            <Route
              component={ForgotPassword}
              key="ForgotPassword"
              path="/ForgotPassword"
            />
            <Route
              component={ChangePassword}
              key="ChangePassword"
              path="/ChangePassword"
            />
            <ProtectedRoute
              component={OnboardingForms}
              key="OnboardingForms"
              path="/OnboardingForms"
            />
            <Route
              component={OnboardingPDF}
              key="OnboardingPDF"
              path="/OnboardingPDF"
            />
            <ProtectedRoute
              component={OnboardingSubmitPage}
              key="OnboardingSubmitPage"
              path="/OnboardingSubmitPage"
            />
            <ProtectedRoute component={OnboardingCandidatesReport} key="OnboardingCandidatesReport" path="/OnboardingCandidatesReport" />
            <Route component={SEZForm} key="SEZForm" path="/SEZForm" />
            <Route component={SEZPDF} key="SEZPDF" path="/SEZPDF" />
            <ProtectedRoute
              component={SEZCandidateList}
              key="SEZCandidateList"
              path="/SEZCandidateList"
              displaySideNavBar={true}
            />
            <ProtectedRoute
              component={ExitEmployeeList}
              key="ExitEmployeeList"
              path="/ExitEmployeeList"
              displaySideNavBar={true}
            />
            <Route
              component={LeaveAndGratuityForm}
              key="LeaveAndGratuityForm"
              path="/LeaveAndGratuityForm"
            />
            <Route component={ExitPDF} key="ExitPDF" path="/ExitPDF" />
          </Switch>
        </div>
      </Container>
    </UserProvider>
  );
};

export default App;
